import React from 'react';
import { G, Path, Svg, Circle, Polygon } from 'react-native-svg';
export const ProcessingComplete = () => {
  return /*#__PURE__*/React.createElement(Svg, {
    width: "36px",
    height: "36px",
    viewBox: "0 0 41 46"
  }, /*#__PURE__*/React.createElement(G, {
    id: "Desktop",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(G, {
    id: "Loan-Progress-Completed-Option-02",
    transform: "translate(-670.000000, -248.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement(G, {
    id: "Group-7",
    transform: "translate(15.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement(G, {
    id: "Group_379",
    transform: "translate(97.988000, 53.000000)"
  }, /*#__PURE__*/React.createElement(G, {
    id: "Apply---01-Copy-2",
    transform: "translate(557.012000, 0.000000)"
  }, /*#__PURE__*/React.createElement(G, {
    id: "GOLD_CHECK"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M33.5298958,15.5995612 C29.0619857,15.5995612 25.4388371,11.9764125 25.4388371,7.50850247 C25.4388371,7.25891388 25.4525507,7.00932529 25.4744926,6.76522216 C23.7328579,6.27153044 21.8979704,6 20,6 C8.9550192,6 0,14.9550192 0,26 C0,37.0449808 8.9550192,46 20,46 C31.0449808,46 40,37.0449808 40,26 C40,21.9188151 38.7767416,18.1283598 36.6785518,14.9632474 C35.7103675,15.3719144 34.6461876,15.5995612 33.5298958,15.5995612 Z",
    id: "Path",
    fill: "#03906A"
  }), /*#__PURE__*/React.createElement(Circle, {
    id: "Oval",
    fill: "#9E8733",
    cx: "34.0964467",
    cy: "6.9035533",
    r: "6.9035533"
  }), /*#__PURE__*/React.createElement(Polygon, {
    id: "Path",
    fill: "#FFFFFF",
    points: "29.2937394 7.11201354 30.6365482 5.76920474 32.9350254 8.0676819 37.2125212 3.79018613 38.5553299 5.13028765 32.9350254 10.7505922"
  })), /*#__PURE__*/React.createElement(G, {
    id: "ICON_-_PENDING",
    transform: "translate(12.702332, 15.739369)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12.866941,20.0823045 L1.56378601,20.0823045 C1.26200274,20.0823045 1.01508916,19.8353909 1.01508916,19.5336077 L1.01508916,17.5308642 C1.01508916,14.1015089 3.1824417,12.1262003 5.51440329,10.5075446 C5.6515775,10.3978052 5.73388203,10.2880658 5.73388203,10.1508916 C5.73388203,10.0137174 5.6515775,9.87654321 5.51440329,9.79423868 C3.15500686,8.17558299 1.01508916,6.20027435 1.01508916,2.77091907 L1.01508916,0.768175583 C1.01508916,0.466392318 1.26200274,0.219478738 1.56378601,0.219478738 L12.8943759,0.219478738 C13.1961591,0.219478738 13.4430727,0.466392318 13.4430727,0.768175583 L13.4430727,2.77091907 C13.4430727,6.20027435 11.2757202,8.17558299 8.97119342,9.79423868 C8.8340192,9.90397805 8.75171468,10.0137174 8.75171468,10.1508916 C8.75171468,10.2880658 8.8340192,10.4252401 8.97119342,10.5075446 C11.303155,12.1262003 13.4430727,14.1015089 13.4430727,17.5308642 L13.4430727,19.5336077 C13.4156379,19.8353909 13.1687243,20.0823045 12.866941,20.0823045 Z M2.11248285,18.9849108 L12.345679,18.9849108 L12.345679,17.5308642 C12.345679,14.7599451 10.7544582,13.0864198 8.34019204,11.4128944 C7.90123457,11.1111111 7.65432099,10.6447188 7.65432099,10.1508916 C7.65432099,9.65706447 7.90123457,9.19067215 8.34019204,8.88888889 C10.7544582,7.21536351 12.345679,5.54183813 12.345679,2.77091907 L12.345679,1.31687243 L2.11248285,1.31687243 L2.11248285,2.77091907 C2.11248285,5.54183813 3.7037037,7.21536351 6.11796982,8.88888889 C6.5569273,9.19067215 6.80384088,9.65706447 6.80384088,10.1508916 C6.80384088,10.6447188 6.5569273,11.1111111 6.11796982,11.4128944 C3.7037037,13.0864198 2.11248285,14.7599451 2.11248285,17.5308642 L2.11248285,18.9849108 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M13.7997257,1.09739369 L0.548696845,1.09739369 C0.24691358,1.09739369 3.89872557e-15,0.85048011 3.89872557e-15,0.548696845 C3.89872557e-15,0.24691358 0.24691358,-1.94936279e-15 0.548696845,-1.94936279e-15 L13.7997257,-1.94936279e-15 C14.1015089,-1.94936279e-15 14.3484225,0.24691358 14.3484225,0.548696845 C14.3484225,0.85048011 14.1015089,1.09739369 13.7997257,1.09739369 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement(Circle, {
    id: "Oval",
    cx: "7.18792867",
    cy: "12.1262003",
    r: "1"
  }), /*#__PURE__*/React.createElement(Circle, {
    id: "Oval",
    cx: "7.18792867",
    cy: "13.7997257",
    r: "1"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M7.18792867,15.0068587 C5.21262003,15.0068587 3.53909465,16.2962963 2.99039781,18.079561 L11.4128944,18.079561 C10.8093278,16.2962963 9.16323731,15.0068587 7.18792867,15.0068587 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M3.26474623,2.35939643 L3.26474623,4.30727023 L3.26474623,4.30727023 L3.26474623,4.36213992 C3.26474623,7.48971193 5.21262003,9.32784636 7.51714678,10.9190672 C8.12071331,11.3305898 8.12071331,12.1262003 7.51714678,12.5651578 C5.21262003,14.1563786 3.26474623,15.994513 3.26474623,19.122085 L3.26474623,19.1769547 L3.26474623,19.1769547 L3.26474623,21.1248285 L14.5953361,21.1248285 L14.5953361,19.122085 C14.5953361,15.994513 12.6474623,14.1563786 10.3429355,12.5651578 C9.739369,12.1536351 9.739369,11.3580247 10.3429355,10.9190672 C12.6474623,9.32784636 14.5953361,7.48971193 14.5953361,4.36213992 L14.5953361,2.35939643 L3.26474623,2.35939643 L3.26474623,2.35939643 Z",
    id: "Path",
    opacity: "0.2"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M3.95061728,5.78875171 C4.66392318,6.77640604 5.73388203,7.57201646 6.61179698,8.14814815 C6.83127572,8.3127572 7.05075446,8.5048011 7.18792867,8.72427984 C7.35253772,8.5048011 7.54458162,8.3127572 7.76406036,8.14814815 C9.38271605,7.02331962 10.0411523,6.28257888 10.4252401,5.78875171 C10.781893,5.3223594 11.0288066,4.82853224 11.1934156,4.33470508 L3.1824417,4.33470508 C3.34705075,4.82853224 3.59396433,5.3223594 3.95061728,5.78875171 L3.95061728,5.78875171 Z",
    id: "Path"
  }))))))));
};
//# sourceMappingURL=ProcessingComplete.js.map